// DE QUÉ PÓLIZA HABLA UNA FILA DEL HISTORIAL — tipo, compañía, plan, número
// y prima, en una línea.
//
// Lissette, 2026-09-13, mirando su propio historial: *"me sigue sin salir a
// qué póliza se le está cambiando las cosas; tiene que decir tipo de póliza
// tal y compañía tal y plan tal"*. Y tenía razón dos veces:
//
//   1. Esta línea vivía DENTRO de `formatDetails` (ClientDetail.jsx), y las
//      dos pestañas la llamaban así:
//          const details = changes.length > 0 ? null : formatDetails(...)
//      O sea que en cuanto había cuadros de ANTES/AHORA —justo la fila de la
//      que se queja, "Póliza actualizada · Premium"— la identidad no se
//      calculaba siquiera. La única fila que la enseñaba era el ALTA, porque
//      el alta no trae diferencias. Un dato que solo se ve cuando no hay nada
//      más que ver.
//   2. Faltaba el TIPO, que es lo primero que ella nombra. Y no vale el enum
//      de la base: seis ramos se guardan como HEALTH, así que un Suplemento
//      se leería "Salud" (regla 144). El servidor sella el ramo exacto en
//      `details.ramo` desde hoy (`tipoExactoDePoliza`); las filas ya escritas
//      solo llevan el enum, y para esas se cae a él.
//
// Vive en su propio módulo —y no dentro de ClientDetail.jsx— para que la
// prueba pueda IMPORTARLA y comprobar lo que devuelve. La versión anterior se
// verificaba con un `toContain` de la línea de código, y esa prueba pasó en
// verde defendiendo exactamente el fallo del que ella se queja hoy (regla
// 140: una prueba que comprueba que una línea está escrita no comprueba que
// funcione).

import { POLICY_TYPES, ENUM_A_TIPO } from './policyTypes.js';

/**
 * @param {object|null} details  el `details` de la fila de activity_logs
 * @param {string} lang          'es' | 'en'
 * @returns {string|null}  "Salud · AETNA · silver 344 · #123 · $55", o null
 *                         cuando la fila no habla de ninguna póliza.
 */
export function identidadDePoliza(details, lang) {
  if (!details || typeof details !== 'object') return null;
  const es = lang === 'es';
  // El ramo exacto si el servidor lo selló; si no, el que le toca al enum.
  //
  // `getPolicyType` NO sirve aquí: cae a POLICY_TYPES[0] (Salud) ante un id
  // desconocido, así que un ramo propio de la agencia se leería como Salud.
  // Enseñar el id crudo es feo; inventar el ramo es peor.
  const ramo = details.ramo || ENUM_A_TIPO[String(details.type || '')] || '';
  const pt = ramo ? POLICY_TYPES.find((p) => p.id === ramo) : null;
  const tipo = pt ? (es ? pt.labelEs : pt.label) : (ramo || null);
  return [
    tipo,
    details.carrier,
    details.planName,
    details.policyNumber ? `#${details.policyNumber}` : null,
    // La prima: al cancelar, es lo que se quiere saber —cuánto dejaba de
    // entrar—; al crear, cuánto se vendió.
    details.monthlyPremium ? `$${details.monthlyPremium}` : null,
  ].filter(Boolean).join(' · ') || null;
}
